import React from 'react';
import './ChronologyAccordance.scss';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../../../services/stringUtil';

type PropsDateNodeSegment = {
  nodeTitle: string;
  nodeSubtitle?: string;
  data?: string;
  last?: boolean;
  styleCircleData?: string;
  currentSegment?: boolean;
  isExpired?: boolean;
  isRejected?: boolean;
  isEdited?: boolean;
};

export const DateSegment = ({
  nodeTitle,
  nodeSubtitle,
  data,
  styleCircleData,
  last = false,
  currentSegment = false,
  isExpired = false,
  isRejected = false,
  isEdited = false
}: PropsDateNodeSegment) => {

  const { t } = useTranslation();

  let liClass = "stylesLi";
  let titleClass = "last-item";
  let subtitleClass = "date-text";
  let dataClass = "date-text";

  if (currentSegment) {
    liClass = "current-segment " + liClass;
    titleClass += " current-segment-title";
    subtitleClass += " current-segment-subtitle";
    dataClass += " current-segment-data";

    if (isExpired) {
      liClass += " expired-segment";
      titleClass += " expired-segment-title";
      subtitleClass += " expired-segment-subtitle";
      dataClass += " expired-segment-data";
    } else if (isRejected) {
      liClass += " rejected-segment";
      titleClass += " rejected-segment-title";
      subtitleClass += " rejected-segment-subtitle";
      dataClass += " rejected-segment-data";
    }

  } else if (!last && styleCircleData) {
    liClass = styleCircleData;
  }

  return (
    <li className={liClass}>
      <p className={titleClass}>
        {!isEdited
          ? <>{nodeTitle}&nbsp;{nodeSubtitle || ''}</>
          : <>
            {nodeTitle}
            <ul>
              {nodeSubtitle?.split(',').map((subtitlePart, index) => (
                <li key={index} className='subtitle-flat'>{" - "}{subtitlePart}</li>
              ))}
            </ul>
          </>}
      </p>

      <br />
      <span className={dataClass}>
        {data!}
        {(isExpired && currentSegment) ? <strong>{' - ' + capitalizeFirstLetter(t('expired'))}</strong> : ''}
      </span>
    </li>
  );
};
